<template>
  <div>
    <header class="header" v-if="EN">
      <div class="header_box">
        <img src='../../assets/logo.svg' @click="changeRouter('/home')" />
        <span class="header_language2" @mouseover="dropBoxOut(3)" @mouseleave="dropBoxIn(3)">
          <img src="../../assets/Earth.svg" alt="logo" class="header_language_logo1">
          <span>{{Language}}</span>
          <img src="../../assets/pull_down.svg" class="header_language_logo2">
          <div class="drop_down_box3" @mouseover="dropBoxOut(3)" @mouseleave="dropBoxIn(3)">
            <div class="drop_box3" v-if="dropBoxValue3" >
              <div class="drop_box_1 drop_box_3" @click="dropBoxIn(3);changeLanguage('EN')">English</div>
              <div class="drop_box_2 drop_box_3" @click="dropBoxIn(3);changeLanguage('CN')">简体中文</div>
            </div>
          </div>
        </span>
        <div class="header_page">
          <span v-for="item in pageList" :key="item.name" class="header_text" @click="changeRouter(item.link)"
          @mouseover="item.name == 'Products' ? dropBoxOut(1) : null"
          @mouseleave="item.name == 'Products' ? dropBoxIn(1) : null">
            {{item.name}}
            <img src="../../assets/pull_down.svg" v-if="item.tab==true">
          </span>
          <div :class="nameList.indexOf(name) > -1 ? `active active${nameList.indexOf(name)}` : 'active active-1'"></div>
          <div class="drop_down_box" @mouseover="dropBoxOut(1)" @mouseleave="dropBoxIn(1)">
            <div class="drop_box" v-if="dropBoxValue">
              <div class="drop_box_1" @click="dropBoxIn(1);changeRouter('/antdiy')">ANTDIY</div>
              <div class="drop_box_2" @click="dropBoxIn(1);changeRouter('/antdiypro')">ANTDIY Pro</div>
            </div>
          </div>
        </div>
        <A-Button text='Get Started' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)"></A-Button>
        <span class="header_text header_sign" @click="goLink(`https://platform.antdiy.vip/#/?source=${source}`)">
          Sign in
        </span>
      </div>
    </header>
    <header class="header header2" v-else>
      <div class="header_box2">
        <img src='../../assets/cloud_logo_white.svg' @click="changeRouter('/cn/home')" class="headlogo" />
        <span class="header_language" @mouseover="dropBoxOut(3)" @mouseleave="dropBoxIn(3)">
          <img src="../../assets/Earth_white.svg" alt="logo" class="header_language_image1">
          <span style="color: #FFFFFF;">{{Language}}</span>
          <img src="../../assets/pull_down.svg" class="header_language_image2">
          <div class="drop_down_box3" @mouseover="dropBoxOut(3)" @mouseleave="dropBoxIn(3)">
            <div class="drop_box3" v-if="dropBoxValue3">
              <div class="drop_box_1" @click="dropBoxIn(3);changeLanguage('EN')">English</div>
              <div class="drop_box_2" @click="dropBoxIn(3);changeLanguage('CN')">简体中文</div>
            </div>
          </div>
        </span>
        <div class="header_page2">
          <span v-for="item in pageList2" :key="item.name" class="header_text2" @click="changeRouter(item.link)" @mouseover="item.name == '立即合作' ? dropBoxOut(2) : null" @mouseleave="item.name == '立即合作' ? dropBoxIn(2) : null">
            {{item.name}}
            <img src="../../assets/pull_down.svg" v-if="item.tab==true">
          </span>
          <div :class="nameList.indexOf(name) > -1 ? `active active${nameList.indexOf(name)}` : 'active active-1'"></div>
          <div class="drop_down_box2" @mouseover="dropBoxOut(2)" @mouseleave="dropBoxIn(2)">
            <div class="drop_box2" v-if="dropBoxValue2">
              <div class="drop_box_1" @click="dropBoxIn(2);changeRouter('/cn/solution/raas')">全球云店</div>
              <div class="drop_box_2" @click="dropBoxIn(2);changeRouter('/cn/solution/baas')">品牌出海</div>
            </div>
          </div>
        </div>
        <div class="header_option_box">
          <span class="header_text2" @click="changeRouter('/cn/about-us')">简介</span>
          <span class="header_text2" @click="changeRouter('/cn/blog')">资讯</span>
          <A-Button text='开始使用' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)" class="header_button"></A-Button>
          <span class="header_text2" @click="goLink(`https://platform.antdiy.vip/#/?source=${source}`)">登录</span>
        </div>
      </div>
    </header>
    <div class="header_empty" :style="EN ? '' : 'height: 90px;'"></div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['name'],
  data () {
    return {
      pageList: [
        {name: 'Home', link: '/home'},
        {name: 'Get Store', link: '/getstore'},
        {name: 'Services', link: '/services'},
        {name: 'Products', link: '/products', tab: true},
        {name: 'Blog', link: '/blog'},
        // {name: 'Support', link: '/support'},
        { name: 'Help Center', link: '/help' },
      ],
      pageList2: [
        {name: '首页', link: '/cn/home' },
        {name: '功能优势', link: '/cn/products'},
        {name: '立即合作', link: '/cn/solution/raas', tab: true},
        // {name: '成功案例', link: '/cn/success'},
        // {name: '博客', link: '/cn/blog'},
      ],
      nameList: ['/home', '/getstore','/services', '/products', '/blog', '/help', '/antdiy', '/antdiypro','/cn/home','/cn/products','/cn/solution/raas','/cn/solution/baas','/cn/success','/cn/about-us', '/cn/blog'],
      nameList2: ['/products','/blog'],
      nameList3: ['/cn/home','/cn/products','/cn/support','/cn/blog'],
      source: localStorage.getItem('ant_source') || '',
      timer: '',
      timer2: '',
      timer3: '',
      dropBoxValue: false,
      dropBoxValue2: false,
      dropBoxValue3: false,
      EN:true,
      Language:'English'
    }
  },
  methods: {
    changeRouter (link) {
      this.$router.push({
        path: link
      }).catch(err => {
      // console.log('e',err)
      })
    },
    goLink (url) {
      window.open(url)
    },
    changeLanguage(index){
      this.dropBoxValue3=false
      if(index=="EN"){
        this.EN=true
        this.Language='English'
        if(this.$route.path.slice(0,3)=='/cn'){
          if(this.nameList3.indexOf(this.$route.path)!=-1){
            this.$router.push({
               path: this.$route.path.slice(3)
            })
          }else{
            this.$router.push({
              path: '/home'
            })
          }
        }
      }else{
        this.EN=false
        this.Language='简体中文'
        if(this.$route.path.slice(0,3)!='/cn'){
          if(this.nameList2.indexOf(this.$route.path)!=-1){
            this.$router.push({
              path: '/cn'+this.$route.path
            })
          }else{
            this.$router.push({
              path: '/cn/home'
            })
          }
        }
      }
    },
    dropBoxOut(index) {
      if (index === 1) {
        clearTimeout(this.timer)
        this.timer = setTimeout(()=>{this.dropBoxValue = true}, 300);
      } else if (index === 2) {
        clearTimeout(this.timer2)
        this.timer2 = setTimeout(()=>{this.dropBoxValue2 = true}, 300);
      } else if (index === 3) {
        clearTimeout(this.timer3)
        this.timer3 = setTimeout(()=>{this.dropBoxValue3 = true}, 300);
      }
    },
    dropBoxIn (index) {
      if (index == 1) {
        clearTimeout(this.timer)
        this.timer = setTimeout(()=>{this.dropBoxValue = false}, 300);
      } else if (index === 2) {
        clearTimeout(this.timer2)
        this.timer2 = setTimeout(()=>{this.dropBoxValue2 = false}, 300);
      } else if (index === 3) {
        clearTimeout(this.timer3)
        this.timer3 = setTimeout(()=>{this.dropBoxValue3 = false}, 300);
      }
    },
  },
  created(){
    if(this.$route.path.slice(0,3)=='/cn'){
      this.EN=false
      this.Language='简体中文'
    }else{
      this.EN=true
      this.Language='English'
    }
  },
  watch: {
    '$route'(to, from) {
      //to表示将要进入的页面路由信息,from是现在所处页面的路由信息
      if(to.path.slice(0,3)=='/cn'){
        this.EN=false
        this.Language='简体中文'
      }else{
        this.EN=true
        this.Language='English'
      }
    }
  }
}
</script>

<style scoped>
  .header_empty{
    height: 100px;
  }
  .header{
    width: 100%;
    background: #fff;
    padding-top: 36px;
    height: 100px;
    position: fixed;
    top: 0;
    z-index: 999;
  }
  .header_box{
    width: 1200px;
    margin: 0 auto 0;
    height: 48px;
  }
  .header_box img{
    height: 48px;
    width: 174px;
    cursor: pointer;
  }
  .header2 {
    padding-top: 0;
    height: 90px;
    background: #010119;
    box-shadow: 0px 5px 8px 0px rgba(238,238,238,0.13);
  }
  .header_box2{
    width: 1200px;
    margin: 0 auto 0;
    height: 44px;
    display: flex;
    align-items: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .headlogo{
    width: 174px;
    height: 44px;
    cursor: pointer;
  }
  .header_language{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 29px;
    width: 113px;
    height: 32px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
  }
  .header_language2{
    width: 113px;
    height: 32px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    margin-left: 29px;
    line-height: 32px;
    text-align: center;
  }
  .header_language_logo1{
    width: 16px!important;
    height: 16px!important;
  }
  .header_language_logo2{
    width: 8px!important;
    height: 8px!important;
  }
  .header_language2 span{
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #2A333F;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 16px;
    margin: 0 2px;
  }
  .header_language span{
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #2A333F;
    letter-spacing: 0;
    font-weight: 400;
    margin: 0 5px 0 6px;
    line-height: 32px;
  }
  .header_language_image1{
    width: 16px;
    height: 16px;
    display: block;
  }
   .header_language_image2{
    width: 8px;
    height: 8px;
    display: block;
  }
  .header_page{
    display: inline-block;
    position: relative;
    margin-left: 128px;
  }
  .header_page2{
    display: inline-block;
    position: relative;
    margin-left: auto;
  }
  .header_text{
    height: 16px;
    font-size: 16px;
    font-family: Helvetica;
    color: #222536;
    line-height: 16px;
    cursor: pointer;
    position: relative;
    display: inline-block;
  }
  .header_text:hover{
    color: #FC5421;
  }
  .header_text2{
    height: 16px;
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    position: relative;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 500;
  }
  .header_text2:hover{
    color: #FC5421;
  }
  .active{
    width: 24px;
    height: 4px;
    background: #FC5421;
    border-radius: 2px;
    position: absolute;
    bottom: -17px;
    left: -33px;
    transform: translate(-50%, 0);
    transition: all 0.4s;
    opacity: 0;
  }
  .active0{
    left: 20px;
    opacity: 1;
  }
  .active1{
    left: 104px;
    opacity: 1;
  }
  .active2{
    left: 197px;
    opacity: 1;
  }
  .active3{
    left: 286px;
    opacity: 1;
  }
  .active4{
    left: 377px;
    opacity: 1;
  }
  .active5{
    left: 460px;
    opacity: 1;
  }
  .active6{
    left: 286px;
    opacity: 1;
  }
  .active7{
    left: 286px;
    opacity: 1;
  }
  .active8{
    left: 15px;
    opacity: 1;
  }
  .active9{
    left: 121.5px;
    opacity: 1;
  }
  .active10{
    left: 244px;
    opacity: 1;
  }
  .active11{
    left: 244px;
    opacity: 1;
  }
  .active12{
    left: 382px;
    opacity: 1;
  }
  .active13{
    left: 360px;
    opacity: 1;
  }
  .active14{
    left: 447px;
    opacity: 1;
  }
  .header_option_box {
    display: flex;
    align-items: center;
    margin-left: 54px;
  }
  .header_button{
    float: unset !important;
    width: 110px;
    height: 44px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1.45px;
    font-weight: 700;
    margin: 0 30px;
  }
  .header_text + .header_text{
    margin-left: 28px;
  }
  .header_text2 + .header_text2{
    margin-left: 54px;
  }
  .header_sign{
    margin-left: 28px;
    margin-right: 40px;
    float: right;
    line-height: 44px;
  }
  .ad_button{
    float: right;
  }
  .header_page img{
    width: 10px;
    height: 10px;
  }
  .drop_down_box {
    position: fixed;
    z-index: 9999999;
  }
  .drop_down_box2 {
    position: fixed;
    z-index: 9999999;
  }
  .drop_down_box3 {
    position: absolute;
    z-index: 9999999;
    top: 38px;
  }
  .drop_box,
  .drop_box2,
  .drop_box3{
    width: 113px;
    height: 68px;
    margin: 20px 0 0 238px;
    background: #ffffff;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
      0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  .drop_box2 {
    width: 100px;
    margin: 15px 0 0 212px;
  }
  .drop_box3{
    margin: 0;
    text-align: left;
  }
  .drop_box_1,
  .drop_box_2 {
    width: 100%;
    height: 32px;
    padding-left: 12px;
    font-size: 14px;
    font-family: Helvetica;
    color: rgba(0, 0, 0, 0.65);
    line-height: 32px;
    background: #ffffff;
  }
  .drop_box_1 {
    margin-top: 2px;
  }
  .drop_box_3{
    padding-left: 16px;
  }
  .drop_box_1:hover,
  .drop_box_2:hover {
    color: #fc5322;
    background: rgba(252, 83, 34, 0.06);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue